// extracted by mini-css-extract-plugin
module.exports = {"currentLevelTitle":"styles_currentLevelTitle__ZVck9","currentLevelInfo":"styles_currentLevelInfo__Qdgw8","currentLevelNotActive":"styles_currentLevelNotActive__ZppMe"};